<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<div>
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:items="constructions"
						:headers="headers.construction"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr class="no-click">
								<td>XXXX/XX/XX</td>
								<td>XXXXXXXX</td>
								<td>2023XXXXXX</td>
								<td>XXXXXX</td>
								<td>XXXX/XX/XX</td>
								<td>XXX</td>
								<td>XXX</td>
								<td>XXX</td>
								<td>XXX</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</div>
			<div v-for="(category, i) in categories" :key="i">
				<h6 class="font-weight-bold text-body-1 mt-4">{{ category.name }}</h6>
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:items="rubbersByCategory(category)"
						:headers="headers.other"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr
								:class="{ 'no-click': !authority_flag }"
								@click="authority_flag ? openMenu(item, category.type) : false"
							>
								<td>XX</td>
								<td>XX</td>
								<td>XX</td>
								<td>XX</td>
								<td>XX</td>
								<td>XX</td>
								<td><p v-text="status(item)" class="pre-wrap" /></td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</div>
			<v-menu v-model="showMenu" :position-x="position.x" :position-y="position.y">
				<v-list>
					<v-list-item @click="openRubberDialog"> 工事部在庫を引き当てる </v-list-item>
					<v-list-item @click="openRequirementDialog"> 資材に作成を依頼する </v-list-item>
				</v-list>
			</v-menu>
			<ConstructionRequirementNewDialog
				:dialog.sync="requirementDialog"
				:type="selectedType"
				:item="selectedItem"
			/>
			<ConstructionRubberNewDialog
				:dialog.sync="rubberDialog"
				:type="selectedType"
				:item="selectedItem"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import ConstructionRequirementNewDialog from "./rubber_components/ConstructionRequirementNewDialog.vue"
import ConstructionRubberNewDialog from "./rubber_components/ConstructionRubberNewDialog.vue"

export default {
	components: {
		CommonFlame,
		ConstructionRequirementNewDialog,
		ConstructionRubberNewDialog,
	},
	data() {
		return {
			title: "材料計画",
			constructions: [],
			rubbers: [],
			categories: [
				// 仮
				{ id: "rubber", name: "ゴムの材料", type: "rubber" },
				{ id: "liquid", name: "液状ゴム", type: "rubber" },
				{ id: "glue", name: "接着剤・接着糊", type: "item_kg" },
				{ id: "other", name: "その他（原価のコートの部分）", type: "item_quantity" },
			],
			selectedType: "",
			selectedItem: {},
			headers: headers(),
			authority_flag: false,
			requirementDialog: false,
			rubberDialog: false,
			showMenu: false,
			position: {
				x: 0,
				y: 0,
			},
			common,
		}
	},
	mounted() {
		this.fetchRubbers()
	},
	methods: {
		fetchRubbers() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/constructions/${this.id}/rubbers`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					this.constructions = [res.data.construction]
					this.rubbers = res.data.rubbers
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openMenu(item, type) {
			this.selectedItem = item
			this.selectedType = type
			this.showMenu = true
			this.position.x = event.clientX
			this.position.y = event.clientY
		},
		openRequirementDialog() {
			this.requirementDialog = true
		},
		openRubberDialog() {
			this.rubberDialog = true
		},
		status(item) {
			// TODO: itemに紐づく引当・依頼データを元に表示
			// 未引当
			// 工事部在庫引当済み（数量: xxx 引当日: xxxx/xx/xx ）
			// 資材依頼済み（数量: xxx 依頼日：xxxx/xx/xx 希望納期: xxxx/xx/xx）
			// ランダムに生成
			return [
				"未引当",
				"工事部在庫引当済み\n(数量: xxx 引当日: xxxx/xx/xx)",
				"資材依頼済み\n(数量: xxx 依頼日：xxxx/xx/xx 希望納期: xxxx/xx/xx)",
			][Math.floor(Math.random() * 3)]
		},
	},
	computed: {
		rubbersByCategory() {
			return (category) => {
				// TODO: ゴム材料、液状ゴム、接着剤・接着糊、その他（原価のコートの部分）で材料を分ける
				// return this.rubbers.filter((rubber) => rubber.category === category) // 仮
				return [
					{ id: 1, name: "ゴム材料", category: "rubber", status: "未引当" },
					{ id: 2, name: "ゴム材料", category: "rubber", status: "未引当" },
				]
			}
		},
	},
}

function headers() {
	return {
		// TODO: value入力(ConstructionIndexPage.vue参照)
		construction: [
			{
				text: "納期",
				value: "",
				width: "120px",
			},
			{
				text: "台帳番号",
				value: "",
				width: "120px",
			},
			{
				text: "製番",
				value: "",
				width: "120px",
			},
			{
				text: "管理No.",
				value: "",
				width: "120px",
			},
			{
				text: "施工期日",
				value: "",
				width: "120px",
			},
			{
				text: "受注先",
				value: "",
				width: "200px",
			},
			{
				text: "プラントメーカー",
				value: "",
				width: "200px",
			},
			{
				text: "施工場所",
				value: "",
				width: "200px",
			},
			{
				text: "工事名",
				value: "",
				width: "200px",
			},
		],
		other: [
			{ text: "項目", value: "", width: "100px" },
			{ text: "種類", value: "", width: "100px" },
			{ text: "寸法・仕様", value: "", width: "100px" },
			{ text: "予算数量", value: "", width: "80px" },
			{ text: "工事部在庫数", value: "", width: "80px" },
			{ text: "引当済数量", value: "", width: "80px" },
			{ text: "引当状態", value: "", width: "300px" },
		],
	}
}
</script>
